import { MetaGamesService } from '../services';
import {
  DailyMetaGameType,
  InstantMetaGameType,
  MetaGamesState,
  MetaGameType,
} from './metaGames.types';
import {
  appLogout,
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
  injectSlice,
} from '@bonanza-social/toolkit/state';

const initialState: MetaGamesState = {
  gameCounts: undefined,
  countDataState: 'idle',
};

export const dailyMetaGameCompleted = createAction<DailyMetaGameType>(
  'metaGames/dailyMetaGameCompleted',
);

export const instantMetaGameCompleted = createAction(
  'metaGames/instantMetaGameCompleted',
);

export const fetchMetaGamesCount = createAsyncThunk(
  'metaGames/getCount',
  async () => await MetaGamesService.getCount(),
);

export const getMetaGameLaunchUrl = createAsyncThunk(
  'metaGames/getLaunchUrl',
  async (prizeDelivery: MetaGameType) =>
    await MetaGamesService.getLaunchUrl({ data: { prizeDelivery } }),
);

const metaGames = createSlice({
  name: 'metaGames',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMetaGamesCount.pending, (state) => {
      state.countDataState =
        state.countDataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(fetchMetaGamesCount.rejected, (state) => {
      state.countDataState = 'rejected';
    });

    builder.addCase(fetchMetaGamesCount.fulfilled, (state, { payload }) => {
      state.countDataState = 'fulfilled';

      state.gameCounts = {
        Wheel: payload.metaGameRewards.Wheel?.count || 0,
        Scratcher: payload.metaGameRewards.Scratcher?.count || 0,
      };
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withMetaGames = injectSlice({
  reducerPath: 'metaGames',
  reducer: metaGames.reducer,
});

const selectMetaGameCounts = withMetaGames.selector(
  (state) => state.metaGames.gameCounts,
);

export const selectMetaGameCount = createSelector(
  [selectMetaGameCounts, (_, gameType: InstantMetaGameType) => gameType],
  (metaGameCounts, gameType) => metaGameCounts && metaGameCounts[gameType],
);

export const selectMetaGamesCountDataState = withMetaGames.selector(
  (state) => state.metaGames.countDataState,
);

declare global {
  interface LazyLoadedSlices {
    metaGames: ReturnType<typeof metaGames.reducer>;
  }
}
